import { resolveStaffModuleAccess } from './staffModulePermissions';

export const CONTRATOS_PROXIMOS_A_VENCER_MODULE_ID = 'contratos_proximos_a_vencer';

function isCompanyContratosProximosAVencerGranted(companyPerms) {
  if (companyPerms === undefined) return false;
  const row = (companyPerms || []).find((p) => p.moduleId === CONTRATOS_PROXIMOS_A_VENCER_MODULE_ID);
  return row?.hasAccess === true;
}

export function resolveContratosProximosAVencerAccess(
  userPerms,
  companyPerms,
  userCompanyPerms,
  roles,
) {
  if (!isCompanyContratosProximosAVencerGranted(companyPerms)) return false;
  return resolveStaffModuleAccess(
    CONTRATOS_PROXIMOS_A_VENCER_MODULE_ID,
    userPerms,
    companyPerms,
    userCompanyPerms,
    roles,
  );
}
